import { render, staticRenderFns } from "./ReportTypeRegister.vue?vue&type=template&id=0f10c121"
import script from "./ReportTypeRegister.vue?vue&type=script&lang=js"
export * from "./ReportTypeRegister.vue?vue&type=script&lang=js"
import style0 from "./ReportTypeRegister.vue?vue&type=style&index=0&id=0f10c121&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports